import React, { useEffect, useState } from "react";
import {useQuery,gql} from "@apollo/client"

const GET_FUND_OVERLAP_PT=gql`
    query GetFundOverlapPt(
        $fundId1:Int!
        $fundId2:Int!
        $holdingMonth:String!
        $holdingYear:String!
    ){
    getFundOverlapPt(fundId1:$fundId1,fundId2:$fundId2,holdingMonth:$holdingMonth,holdingYear:$holdingYear)    
    }
    
`;

export default GET_FUND_OVERLAP_PT;